export default __webpack_public_path__ + "static/media/des-3.4255dc37.jpg";